import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

export default (country, dpId, startDate, endDate) => {
  const client = getApiClient(apiClients, country)
  const url = `/2.0/dps/${dpId}/volumes-by-type?start_month=${startDate}&end_month=${endDate}`
  return client.get(url)
}
